/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2022, Zumper
 */

/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import { BREAKPOINT_MOBILE } from '@zcode-ui/themes'
import { createLazyLoadableSection } from '@zcode/lazy-loadable-section'
import { ErrorFallback, LoadingFallback } from '@zcode/nr/es/shared/components/Fallback'
import type { ErrorBoundaryProps } from 'react-error-boundary'

import { logger } from '../../../logger'

const fallbackStyle = css`
  min-height: 455px;
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    min-height: 1490px;
  }
`

const onRenderError: ErrorBoundaryProps['onError'] = (error, info) => {
  logger.error('render error for AddressRentTrendsContainer lazy loadable section', info, error)
}

const onLoadingError = (error: unknown) => {
  logger.error('loading error for AddressRentTrendsContainer lazy loadable section', error)
}

const loadFn = /* #__LOADABLE__ */ async () =>
  await import(/* webpackChunkName: "AddressRentTrendsContainer" */ './AddressRentTrendsContainer')

const handleReload = async () => await AddressRentTrendsLazySection.reload()

const options = {
  errorFallback: () => (
    <ErrorFallback
      css={fallbackStyle}
      message="Error loading the rent trends"
      onClickReload={handleReload}
    />
  ),

  loadingFallback: () => <LoadingFallback css={fallbackStyle} name="rent trends" />,
  onRenderError,
  onLoadingError,
}

export const AddressRentTrendsLazySection = createLazyLoadableSection(loadFn, options)
